// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__tY_Gw","loader__line":"styles_loader__line__1WRD1","placeHolderShimmer":"styles_placeHolderShimmer__euF-E","header":"styles_header__2Hw3X"};